import { CheckCircle2, AlertCircle, XCircle, Circle, Clock } from "lucide-react";

const CONFIG = {
  aprobado:  { label: "Aprobado",  cls: "status-approved",  Icon: CheckCircle2 },
  pendiente: { label: "Pendiente", cls: "status-pending",   Icon: Clock },
  revisado:  { label: "Revisado",  cls: "status-pending",   Icon: AlertCircle },
  rechazado: { label: "Rechazado", cls: "status-rejected",  Icon: XCircle },
  missing:   { label: "Falta",     cls: "status-missing",   Icon: Circle },
};

export default function StatusBadge({ status, className = "" }) {
  const cfg = CONFIG[status] || CONFIG.missing;
  const { Icon } = cfg;
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium ${cfg.cls} ${className}`}
    >
      <Icon className="h-3.5 w-3.5" />
      {cfg.label}
    </span>
  );
}
